import React, { useMemo, useState } from "react";
import { StyleSheet, View } from "react-native";
import { Checkbox } from "react-native-paper";

import CustomText from "../../common/general/CustomText/CustomText";
import CustomSearchInput from "../../common/general/CustomSearchInput/CustomSearchInput";
import FilterDropdown from "../../common/TableControls/FilterDropdown";
import { SUBMISSION_TYPE_OPTIONS, useGradingCenterSubmissions } from "../../../contexts/GradingCenterContext";

const GradingCenterFilters: React.FC = () => {
  const {
    selectedCourse,
    setSelectedCourse,
    selectedModule,
    setSelectedModule,
    selectedType,
    setSelectedType,
    showOnlyUngraded,
    setShowOnlyUngraded,
    searchQuery,
    setSearchQuery,
    courseData,
  } = useGradingCenterSubmissions();

  // Dropdown state management
  const [courseDropdownOpen, setCourseDropdownOpen] = useState(false);
  const [moduleDropdownOpen, setModuleDropdownOpen] = useState(false);
  const [typeDropdownOpen, setTypeDropdownOpen] = useState(false);

  const courseItems = useMemo(() => {
    const items = [{ label: "All Courses", value: "" }];
    if (courseData?.getCoursesByFaculty?.data) {
      courseData.getCoursesByFaculty.data.forEach((course) => {
        items.push({ label: course.name, value: course.id });
      });
    }
    return items;
  }, [courseData]);

  const moduleItems = useMemo(() => {
    const items = [{ label: "All Modules", value: "" }];
    if (courseData?.getCoursesByFaculty?.data) {
      courseData.getCoursesByFaculty.data.forEach((course) => {
        course.modules.forEach((module) => {
          items.push({ label: module.title, value: module.id });
        });
      });
    }
    return items;
  }, [courseData]);

  return (
    <View style={styles.filtersContainer}>
      <View style={styles.filtersLeft}>
        <View style={styles.filterGroup}>
          <FilterDropdown
            filterValue={selectedCourse}
            setFilterValue={setSelectedCourse}
            filterDropdownOpen={courseDropdownOpen}
            setFilterDropdownOpen={setCourseDropdownOpen}
            filterItems={courseItems}
            label="filter_by_course"
            placeholder="All Courses"
          />
        </View>
        {/* Hide to stop filter overlap until components can be updated */}
        <View style={styles.filterGroup}>
          <FilterDropdown
            filterValue={selectedModule}
            setFilterValue={setSelectedModule}
            filterDropdownOpen={moduleDropdownOpen}
            setFilterDropdownOpen={setModuleDropdownOpen}
            filterItems={moduleItems}
            label="filter_by_module"
            placeholder="All Modules"
          />
        </View>
        <View style={styles.filterGroup}>
          <FilterDropdown
            filterValue={selectedType}
            setFilterValue={setSelectedType}
            filterDropdownOpen={typeDropdownOpen}
            setFilterDropdownOpen={setTypeDropdownOpen}
            filterItems={SUBMISSION_TYPE_OPTIONS}
            label="filter_by_type"
            placeholder="All Types"
          />
        </View>
        <View style={styles.filterGroup}>
          <View style={styles.checkboxContainer}>
            <Checkbox
              status={showOnlyUngraded ? "checked" : "unchecked"}
              onPress={() => setShowOnlyUngraded(!showOnlyUngraded)}
              theme={{ colors: { primary: "#3B82F6" } }}
            />
            <CustomText text="Show Only Ungraded" size="s" style={styles.checkboxLabel} />
          </View>
        </View>
      </View>
      <View style={styles.searchContainer}>
        <CustomSearchInput
          placeholder="Search student name, course, assignment title"
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  filtersContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: 16,
    borderBottomWidth: 1,
    borderBottomColor: "#E5E7EB",
    zIndex: 10,
  },
  filtersLeft: {
    flexDirection: "row",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 16,
  },
  filterGroup: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
  },
  // filterLabel: {
  //   color: "#374151",
  // },
  // selectContainer: {
  //   paddingHorizontal: 8,
  //   paddingVertical: 4,
  //   borderWidth: 1,
  //   borderColor: "#D1D5DB",
  //   borderRadius: 4,
  //   backgroundColor: "#fff",
  // },
  // selectText: {
  //   color: "#374151",
  // },
  checkboxLabel: {
    color: "#374151",
  },
  checkboxContainer: {
    flexDirection: "row",
    alignItems: "center",
  },
  searchContainer: {
    flex: 1,
    maxWidth: 400,
    alignItems: "flex-end",
  },
});

export default GradingCenterFilters;
